import { useCallback, useState } from 'react'

import {
  checkPasswordStrength,
  PasswordStrengthResult,
} from '@/utils/auth/passwordStrength'

export function usePasswordStrength() {
  const [result, setResult] = useState<PasswordStrengthResult | null>(null)

  const checkStrength = useCallback((password: string) => {
    if (!password.trim()) {
      setResult(null)
      return
    }
    setResult(checkPasswordStrength(password))
  }, [])

  return { result, checkStrength }
}
